module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.wechatLoginUrl
    },
    on: {
      "click": _vm.setRedirectUrlCookie
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/oAuthLogin/wechat.png",
      "alt": "wechat"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-407dcbb1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginform/wechatLogin/WechatLogin.vue
// module id = 1306
// module chunks = 1